import { IFormCellProps } from './FormCell';

export const extractFormCellProps = <T>(
  props: IFormCellProps & T
): { formCellProps: IFormCellProps; inputProps: T } => {
  const {
    className,
    errorText,
    hintText,
    isRequired,
    label,
    maxCharacterCount,
    currentCharacterCount,
    wrapInput,
    ...rest
  }: IFormCellProps & T = props;
  return {
    formCellProps: {
      className,
      errorText,
      hintText,
      isRequired,
      label,
      wrapInput,
      disabled: rest.disabled,
      action: rest.action,
      maxCharacterCount,
      currentCharacterCount,
    },
    inputProps: rest as T,
  };
};
